<template>
  <div class="modal offer-modal">
    <div class="overlay"  @click="$emit('closeOfferDetailsModal')"></div>
    <div class="wrapper">
      <img class="close" @click="$emit('closeOfferDetailsModal')" src="./../assets/close.svg"/>
      <div class="container">
        <form>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title small">Order #{{$parent.orderToView.id}}</div>
              <div class="form-fields-wrapper">
                <div class="offer-wrapper">
                  <div class="row">
                    <div class="title">Skin name</div>
                    <div class="desc">{{$parent.orderToView.title}}</div>
                  </div>
                  <div class="row">
                    <div class="title">Quality</div>
                    <div class="desc">{{$parent.orderToView.quality}}</div>
                  </div>
                  <!-- <div class="row">
                    <div class="title">Item count</div>
                    <div class="desc">{{$parent.orderToView.count}}</div>
                  </div> -->
                  <div class="row">
                    <div class="title">Your price</div>
                    <div class="desc">{{$parent.orderToView.user_price}} {{$parent.orderToView.currency}}</div>
                  </div>
                  <div class="row">
                    <div class="title">Our price</div>
                    <div class="desc">{{$parent.orderToView.service_price}} {{$parent.orderToView.currency}}</div>
                  </div>
                  <div class="buttons" v-if="$parent.orderToView.status === 'offer'">
                    <div class="button" @click="decline()" :class="{'disabled': loading}">
                      {{loading && actionType === 'decline' ? 'Processing...' : 'Decline'}}
                    </div>
                    <div class="button" @click="accept()" :class="{'disabled': loading}">
                      {{loading && actionType === 'accept' ? 'Processing...' : 'Accept'}}
                    </div>
                  </div>
                  <div class="buttons" v-else-if="$parent.orderToView.status === 'ready_for_payout'">
                    <div class="button blue" @click="withdraw()">Withdraw</div>
                  </div>
                  <div class="status-info" v-else>
                    <div class="desc status-text">Status: {{getStatusText($parent.orderToView.status)}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OfferDetailsModal',
  props: ['orderToView'],
  components: {
  },
  data: function() {
    return {
      loading: false,
      actionType: null
    }
  },
  methods: {
    closeOfferDetailsModal() {
      this.$emit('closeOfferDetailsModal')
    },
    decline() {
      if (this.loading) return;
      
      this.loading = true;
      this.actionType = 'decline';
      
      let data = {
        'id': this.$parent.orderToView.id
      }
      this.$http.post(process.env.VUE_APP_API + 'offer/decline', data)
      .then(() => {
        this.closeOfferDetailsModal();
      })
      .catch((res) => {
        this.$parent.setError(res.response.data.message || 'Something went wrong');
      })
      .finally(() => {
        this.loading = false;
        this.actionType = null;
      })
    },
    accept() {
      if (this.loading) return;
      
      this.loading = true;
      this.actionType = 'accept';
      
      let data = {
        'id': this.$parent.orderToView.id
      }
      this.$http.post(process.env.VUE_APP_API + 'offer/accept', data)
      .then(() => {
        this.closeOfferDetailsModal();
      })
      .catch((res) => {
        this.$parent.setError(res.response.data.message || 'Something went wrong');
      })
      .finally(() => {
        this.loading = false;
        this.actionType = null;
      })
    },
    withdraw() {
      this.$parent.openAcceptOfferModal();
    },
    getStatusText(status) {
      const statusMap = {
        'pending': 'Pending Review',
        'offer': 'Offer Available',
        'awaiting_item': 'Awaiting Item',
        'ready_for_payout': 'Ready for Payout',
        'payout_processing': 'Payout Processing',
        'approved': 'Completed',
        'declined_by_user': 'Declined by You',
        'declined_by_service': 'Declined by Service'
      };
      return statusMap[status] || status;
    }
  }
}
</script>

<style scoped>
.button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.status-info {
  text-align: center;
  padding: 16px 0;
}

.status-text {
  font-weight: 500;
  color: #888;
}
</style>